import React, { useEffect, useState } from 'react'
import Header from '../Partials/Header'
import Footer from '../Partials/Footer'
import { toast } from "react-toastify";
import emailjs from 'emailjs-com';
import { useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const navigate = useNavigate();

  const inputHandle = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }

  const sendEmail = (formData) => {
    emailjs.send(
      process.env.REACT_APP_SERVICE_ID,    // Replace with your EmailJS Service ID
      process.env.REACT_APP_TEMPLATE_ID_CONTACTUS,   // Replace with your EmailJS Template ID
      formData,             // Data from the form fields
      process.env.REACT_APP_PUBLIC_KEY     // Replace with your EmailJS Public Key
    )
      .then((response) => {
        // console.log('SUCCESS!', response.status, response.text);
      })
      .catch((error) => {
        console.error('FAILED...', error);
      });
  };

  const contactUsSubmit = (e) => {
    e.preventDefault();
    try {
      // navigate("/bookappointment");
      // return;
      if (Object.values(formData).some(value => value.trim() === "")) {
        toast.error("Please fill out all fields.", {
          position: "top-center",
          autoClose: 2000,
        });
        return;
      }
      var message = `My name is ${formData.name}. I am register my self using your website contact-us section. My mail id is ${formData.email} and My other details is following\nPhone: ${formData.phone},\nSubject: ${formData.subject},\nMessage: ${formData.message}. Please contact me.`

      const v = { email: "drchinala@witcare.health", name: "Dr. Chinala", message: message, subject: "Contact us from website." };
      sendEmail(v)
      setFormData({ email: "", name: "", subject: "", message: "", phone: "" });
      toast.success("Your application is submitted, we will reach you soon.", {
        position: "top-center",
        autoClose: 2000,
      });
    } catch (error) {
      console.log("contactUsSubmit", error);
    }
  }

  useEffect(() => {
    const initMap = () => {
      const location = { lat: 40.4369952, lng: -74.5401416 };
      const map = new window.google.maps.Map(document.getElementById("myMap"), {
        zoom: 12,
        center: location,
      });
      new window.google.maps.Marker({
        position: location,
        map: map,
      });
    };

    const loadMapScript = () => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyB3Ao8313zFgUeFM8G4C7QREbal_Pmy0Ng&callback=initMap`;
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
      script.onerror = () => {
        console.error("Google Maps script failed to load.");
      };
      window.initMap = initMap; // Assign initMap to the global window object
    };

    // Check if Google Maps is already loaded
    if (window.google && window.google.maps) {
      initMap();
    } else {
      loadMapScript();
    }
  }, []);

  return (
    < >
      {/* Slider Area */}
      <Header />
      <section className="">
        {/* Start Single Slider */}
        <div
          className="slide-img"
          style={{ backgroundColor: "aliceblue" }}
        // style={{ backgroundImage: 'url("/assets/img/slider4.png")' }}
        >
          <div className="container">
            <div className="row d-flex justify-content-center">
              <div className="col-lg-7 ">
                <div className="text">
                  <h1>
                    Welcome to <span>WitCare Psychiatrists</span>
                  </h1>
                  <h5>
                    We can connect you with a specialist consultant psychiatrist or
                    therapist today, covering a full range of mental health
                    conditions and treatment options.
                  </h5>
                  <div className="my-available">
                    <span>
                      <i className="icofont-phone" />
                      <i className="icofont-video" />
                      Available both in-person and online
                    </span>
                  </div>
                  {/*<div className="button">
                      <a href="#bookappoinment" className="btn">Get Appointment</a>
                    </div>*/}
                </div>
              </div>
              {/* <div className="col-lg-5">
                <img src="/assets/img/1.jpg" alt="Banner" />
              </div> */}
            </div>
          </div>
        </div>
      </section>
      {/* Start Why choose */}
      <section className="why-choose section" id="about">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-12">
              {/* Start Choose Rights */}
              <div className="mt-4 about-img">
                <img src="/assets/img/doctor_PNG1603412.png" alt="Banner" />
              </div>
              {/* End Choose Rights */}
            </div>
            <div className="col-lg-6 col-12">
              {/* Start Choose Left */}
              <div className="choose-left about-text" style={{ marginTop: "2rem" }}>
                <h3>About</h3>
                <h1>Dr. Sandhya Chinala</h1>
                <h5 className="doctor-nw">Psychiatrist, MD</h5>
                {/* <p>
                  I am board- certified in general psychiatry, completed fellowship
                  in child &amp; adolescent psychiatry and licensed to practice in
                  New Jersey. My practice is geared towards providing
                  psychopharmacology to functional individuals.
                </p> */}
                <p>
                  My name is Sandhya Chinala. I am double board- certified in adult & child psychiatry,
                  I am licensed to practice in New Jersey. My practice is geared towards providing
                  psychopharmacology, psychotherapy and holistic approaches. I help adults,
                  children and adolescents with clinical depression, anxiety disorders, ADHD, OCD, PTSD,
                  and a variety of other mental health and wellness issues. I believe in a comprehensive,
                  careful evaluation and systematic plan for treatment.

                </p>
                <h6> My Education and Training:</h6>
                <p>I was born and raised in India. I was always passionate about learning different languages
                  and cultures. At the age of ten, I was able to communicate in 4 different languages. Language 
                  helps understand and communicate complex social relationships. At the age of eighteen, I moved 
                  to Moscow, Russia to embark on my studies. Following completion of medical school in 2003, I returned to India 
                  and worked there for about 10 years. I completed my adult residency from Harlem Hospital Center, Columbia University 
                  Affiliation, New York in 2019. I served as a chief resident during my 4th and final year of residency, the program rewarded 
                  me with outstanding resident awards for 3 consecutive years. After completion of residency, I aspired to acquire clinical skills 
                  in working with children, adolescents, and their families to facilitate early intervention and preventive measures that would help a
                  great deal in treating and preventing psychopathology. I attended child and adolescent psychiatry fellowship program at Rutgers-Robert Wood
                  Johnson Medical School, New Jersey and graduated in June 2021. During my training period, I got an opportunity to teach medical students and 
                  participate in various research projects.</p>
                {/* <p>
                  Medical School – Russian State Medical University, Moscow, Russia
                  Residency. General Psychiatry – Harlem Hospital Center, Columbia
                  University Affiliation, New York. Fellowship, Child &amp;
                  Adolescent Psychiatry – Rutgers- RWJMS.
                </p> */}
                <h6>Languages Spoken Fluently:</h6>                
                <p>English, Hindi, Telugu, Tamil </p>
                {/* <p>
                  I help children, adolescents and adults with clinical depression,
                  anxiety disorders, ADHD, OCD, PTSD, and a variety of other mental
                  health and wellness issues. I perform comprehensive psychiatric
                  evaluation. I believe in good listening, effective communication,
                  comprehensive, careful evaluation and systematic plan for
                  treatment.
                </p> */}
              </div>
              {/* End Choose Left */}
            </div>
          </div>
        </div>
      </section>
      {/*/ End Why choose */}
      {/* Start Call to action */}
      <section className="call-action overlay" data-stellar-background-ratio="0.5">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-12">
              <div className="content">
                <h2>Do you need Emerency Psychiatry? Call @ +732 960 1899</h2>
                <div className="button my-3">
                  <a href="#contact" className="btn">
                    Contact Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/*/ End Call to action */}
      <section className="services mt-5" id="service">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>Our Services</h2>
                <img src="/assets/img/section-img.png" alt="#" />
              </div>
            </div>
            <div className="col-md-4 col-12 p-2 ">
              <div className="specialties-info">
                {/* <img className="" src="/assets/img/icons/asset-1.svg" /> */}
                <div className="specialties-content">
                  <h3>Psychiatric Evaluation</h3>
                  <p>
                    Thorough Psychiatric Evaluation/Assessment/formulation/plan for Adults, Children & Adolescents.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12 p-2 ">
              <div className="specialties-info">
                {/* <img className="" src="/assets/img/icons/asset-2.svg" /> */}
                <div className="specialties-content">
                  <h3>Medication Management</h3>
                  <p>
                    Thoughtful psychotropic medication management for Adults, Children & Adolescents.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 col-12 p-2 ">
              <div className="specialties-info">
                {/* <img className="" src="/assets/img/icons/asset-3.svg" /> */}
                <div className="specialties-content">
                  <h3>Psychotherapy</h3>
                  <p>
                    We prefer our clients to work with an outside counselor/therapist. Dr. Chinala would like to collaborate with your therapist to better individualize the treatment plan.
                  </p>
                </div>
              </div>
            </div>
            {/* <div className="col-md-6 col-12 ">
              <div className="specialties-info">
                <div className="specialties-content">
                  <h3>Transcranial Magnetic Stimulation (TMS)</h3>
                  <p>
                    Transcranial magnetic stimulation (TMS) is a noninvasive procedure that uses magnetic fields to stimulate nerve cells in the brain to improve symptoms of depression.We will be starting the services in the near future, please contact us for the updates.
                  </p>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>
      <section className="services section" id="services">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>Specialties and Expertise</h2>
                <img src="/assets/img/section-img.png" alt="#" />
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-1.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Depression</h3>
                  <p>
                    Depression is a common mental health condition that affects
                    millions worldwide, impacting both emotions and daily life.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-2.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Anxiety</h3>
                  <p>
                    Anxiety a natural response that can be managed for a more
                    balanced life
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-3.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Mood Disorders</h3>
                  <p>
                    Mood disorders include a wide variety of conditions that affect
                    emotions, from depression to bipolar disorder.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-4.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>ADHD</h3>
                  <p>
                    ADHD is a neurodevelopmental condition that affects focus and
                    impulse control.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-5.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Bipolar Disorder</h3>
                  <p>
                    Bipolar Disorder is a mental health condition characterized by
                    extreme mood swings
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-6.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Impulse Control Disorders</h3>
                  <p>
                    {" "}
                    Involve difficulty resisting urges or impulses, and
                    understanding these conditions is crucial for..
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-7.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Obsessive-Compulsive (OCD)</h3>
                  <p>
                    Explore OCD resources and find relief through understanding and
                    guidance.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-8.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Psychosis</h3>
                  <p>
                    Psychosis refers to a collection of symptoms that affect the
                    mind, where there has been some loss of contact with reality.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-9.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Self-Harming</h3>
                  <p>
                    Self-harm is when you hurt yourself as a way of dealing with
                    very difficult feelings...
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-10.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Sleep or Insomnia</h3>
                  <p>
                    Insomnia is a common sleep disorder that can make it hard to
                    fall asleep, hard to stay asleep...
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-2.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Stress</h3>
                  <p>
                    Stress can be defined as a state of worry or mental tension
                    caused by a difficult situation.{" "}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-11.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Suicidal Ideation</h3>
                  <p>
                    Intentional self-injurious thoughts and behavior may be suicidal
                    or nonsuicidal
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-12 ">
              <div className="specialties-info">
                <img className="" src="/assets/img/icons/asset-12.svg" alt="Banner" />
                <div className="specialties-content">
                  <h3>Trauma and PTSD</h3>
                  <p>
                    A disorder characterised by failure to recover after
                    experiencing or witnessing a terrifying event.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* <section className="appointment section" id="bookappoinment">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>We Are Always Ready to Help You. Book An Appointment</h2>
                <img src="/assets/img/section-img.png" alt="#" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6 col-md-12 col-12">
              <form className="form" action="#">
                <div className="row">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="form-group">
                      <input name="name" type="text" placeholder="Name" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="form-group">
                      <input name="email" type="email" placeholder="Email" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="form-group">
                      <input name="phone" type="text" placeholder="Phone" />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="form-group">
                      <div className="nice-select form-control wide" tabIndex={0}>
                        <span className="current">Department</span>
                        <ul className="list">
                          <li>Psychiatrist</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="form-group">
                      <div className="nice-select form-control wide" tabIndex={0}>
                        <span className="current">Doctor</span>
                        <ul className="list">
                          <li data-value={1} className="option selected ">
                            Dr. Sandhya Chinala
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="form-group">
                      <input type="text" placeholder="Date" id="datepicker" />
                    </div>
                  </div>
                  <div className="col-lg-12 col-md-12 col-12">
                    <div className="form-group">
                      <textarea
                        name="message"
                        placeholder="Write Your Message Here....."
                        defaultValue={""}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-5 col-md-4 col-12">
                    <div className="form-group">
                      <div className="button">
                        <button type="submit" className="btn">
                          Book An Appointment
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-7 col-md-8 col-12">
                    <p>( We will be confirm by an Text Message )</p>
                  </div>
                </div>
              </form>
            </div>
            <div className="col-lg-6 col-md-12 book-ap">
              <div className="">
                <img src="https://manoshanti.com/wp-content/uploads/2023/06/3-2.png" />
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* End Appointment */}
      {/* Start Blog Area */}
      {/* <section className="blog section testimonials" id="testimonials">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h2> Testimonials</h2>
                <img src="/assets/img/section-img.png" alt="#">
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-news">
                <div className="news-head">
                  <img src="/assets/img/author3.jpg" alt="#">
                </div>
                <div className="news-body">
                  <div className="news-content">
                    <div className="date">22 Aug, 2023</div>
                    <h2><a href="blog-single.html">Ann Williams</a></h2>
                    <p className="text">Dr. Sandhya Chinala is the best Sociology surgeon! She is very experienced, as well as friendly, supportive, and always ready to help.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-news">
                <div className="news-head">
                  <img src="/assets/img/author2.jpg" alt="#">
                </div>
                <div className="news-body">
                  <div className="news-content">
                    <div className="date">15 Jul, 2023</div>
                    <h2><a href="blog-single.html">Adam Smith</a></h2>
                    <p className="text">Thanks to Dr. Sandhya Chinala, I can now enjoy my life to the fullest. Thank you for your help and the care you have provided. Onece again Heartfully Thanks.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-12">
              <div className="single-news">
                <div className="news-head">
                  <img src="/assets/img/author1.jpg" alt="#">
                </div>
                <div className="news-body">
                  <div className="news-content">
                    <div className="date">05 Jan, 2023</div>
                    <h2><a href="blog-single.html">Michelle King</a></h2>
                    <p className="text">I found Dr. Sandhya Chinala to be a truly engaging and pleasant person. Her patient rapport is excellent and she explains everything.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>*/}
      <section className="section" style={{ paddingBottom: 0 }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-title">
                <h2>Frequently Asked Questions</h2>
                <img src="/assets/img/section-img.png" alt="#" />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 faq">
              <div className="faq-container">
                <details className="faq-box" open="">
                  <summary className="faq-header">
                    Do I need a referral?
                    <span>
                      <i className="icofont-thin-down" />
                    </span>
                  </summary>
                  <div className="faq-content">
                    <p>
                      It’s usually not necessary and our psychiatrists can see you
                      directly without a referral. We are happy to accept referrals
                      from your GP, other medical doctors, psychologists and other
                      mental health professionals. Please note: In certain cases
                      some private medical insurance organisations might expect you
                      to have a formal referral. Please check with your insurance
                      provider in advance.
                    </p>
                  </div>
                </details>
                <details className="faq-box">
                  <summary className="faq-header">
                    What happens during the initial consultation?
                    <span>
                      <i className="icofont-thin-down" />
                    </span>
                  </summary>
                  <div className="faq-content">
                    <p>
                      An initial psychiatric consultation aims to look into your
                      symptoms and to understand how those symptoms developed, what
                      different factors in your life influenced them, and what can
                      be done to help. It will typically end with a treatment plan
                      which may include scripts, referrals to therapists or other
                      professionals, or follow-up appointments.
                    </p>
                  </div>
                </details>
                <details className="faq-box">
                  <summary className="faq-header">
                    How long does the appointment last?
                    <span>
                      <i className="icofont-thin-down" />
                    </span>
                  </summary>
                  <div className="faq-content">
                    {/* <p>
                      Most initial consultations are between one and two hours long,
                      depending on your specific requirements.
                    </p> */}
                    <p>
                      Initial appointment: 60-90 minutes. <br /> Follow up appointments: 30-45 minutes
                    </p>
                  </div>
                </details>
                <details className="faq-box">
                  <summary className="faq-header">
                    Can I have an online consultation?
                    <span>
                      <i className="icofont-thin-down" />
                    </span>
                  </summary>
                  <div className="faq-content">
                    {/* <p>
                      It depends on your specific condition and the psychiatrist
                      that you’re seeing, but in most cases it is possible to
                      arrange. Contact us to discuss.
                    </p> */}
                    <p>
                      In-person is preferred but yes we can do tele-visits.
                    </p>
                  </div>
                </details>
                <details className="faq-box">
                  <summary className="faq-header">
                    How many sessions does a full psychiatric assessment take?
                    <span>
                      <i className="icofont-thin-down" />
                    </span>
                  </summary>
                  <div className="faq-content">
                    <p>
                      For most conditions, one appointment is enough to produce a
                      thorough diagnosis and treatment plan.
                    </p>
                  </div>
                </details>
                {/* <details className="faq-box">
                  <summary className="faq-header">
                    What can I expect to happen with ADHD’s long-term implications?
                    <span>
                      <i className="icofont-thin-down" />
                    </span>
                  </summary>
                  <div className="faq-content">
                    <p>
                      There is no single path for all individuals. For example, in
                      many cases even without treatment, the symptoms of ADHD tend
                      to improve over time through adult life, but in any case it
                      can have a significant impact on people’s ability to work and
                      maintain relationships. Therefore it’s always important, if
                      you think that you’re having difficulties with this, to come
                      and seek a professional assessment and treatment without
                      unnecessary delay.
                    </p>
                  </div>
                </details> */}
                <details className="faq-box">
                  <summary className="faq-header">
                    How long does it take for the psychiatric appointment?
                    <span>
                      <i className="icofont-thin-down" />
                    </span>
                  </summary>
                  <div className="faq-content">
                    <p>
                      We can typically get appointments booked within one week.
                      {/* Depending on availability, we can also offer last-minute
                      appointments – call us to enquire about availability. */}
                    </p>
                  </div>
                </details>
                <details className="faq-box">
                  <summary className="faq-header">
                    What’s the fee for your service?
                    <span>
                      <i className="icofont-thin-down" />
                    </span>
                  </summary>
                  <div className="faq-content">
                    {/* <p>
                      There is no “one suits all” fee. Different experts charge
                      individually customised fees. Certain complex issues require a
                      highly specialised expert, and the charge can be higher with
                      these. You are advised to contact us to
                      find out the details applicable to your specific needs. Please note that We are not accepting insurance.
                    </p> */}
                    <p>
                      Initial appointment- $ 150 <br />
                      Follow up appointment- & 75
                    </p>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        className="contact-us section"
        id="contact"
        style={{ paddingBottom: 0, position: "relative", zIndex: "1" }}
      >
        <div className="container">
          <div className="inner">
            <div className="row">
              <div className="col-lg-6">
                <div className="contact-us-left">
                  {/*Start Google-map */}
                  <div id="myMap" style={{ height: '500px', width: '100%' }}></div>
                  {/*/End Google-map */}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="contact-us-form">
                  <h2>Contact With Us</h2>
                  <p>
                    If you have any questions please fell free to contact with us.
                  </p>
                  {/* Form */}
                  <form className="form" onSubmit={contactUsSubmit}>
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="name"
                            placeholder="Name"
                            onChange={inputHandle}
                            value={formData.name}
                            required
                          />

                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="email"
                            name="email"
                            onChange={inputHandle}
                            placeholder="Email"
                            value={formData.email}
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="phone"
                            onChange={inputHandle}
                            value={formData.phone}
                            placeholder="Phone"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="form-group">
                          <input
                            type="text"
                            name="subject"
                            onChange={inputHandle}
                            value={formData.subject}
                            placeholder="Subject"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-lg-12">
                        <div className="form-group">
                          <textarea
                            name="message"
                            placeholder="Your Message"
                            required
                            onChange={inputHandle}
                            value={formData.message}
                          />
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group login-btn">
                          <button className="btn" type="submit">
                            Send
                          </button>
                        </div>

                      </div>
                    </div>
                  </form>
                  {/*/ End Form */}
                </div>
              </div>
            </div>
          </div>
          <div className="contact-info">
            <div className="row">
              {/* single-info */}
              <div className="col-lg-4 col-12 ">
                <div className="single-info">
                  <i className="icofont icofont-ui-call" />
                  <div className="content">
                    <h3>+(732) 960-1899</h3>
                    <p>drchinala@witcare.health</p>
                  </div>
                </div>
              </div>
              {/*/End single-info */}
              {/* single-info */}
              <div className="col-lg-4 col-12 ">
                <div className="single-info">
                  <i className="icofont-google-map" />
                  <div className="content">
                    <h3>3084 State Route 27,</h3>
                    <p>Suite # 8 Kendall Park,</p>
                    <p>NJ 08824</p>
                  </div>
                </div>
              </div>
              {/*/End single-info */}
              {/* single-info */}
              <div className="col-lg-4 col-12 ">
                <div className="single-info">
                  <i className="icofont icofont-wall-clock" />
                  <div className="content">
                    <h3>Monday - Sunday</h3>
                    <p>24/7 Open</p>
                  </div>
                </div>
              </div>
              {/*/End single-info */}
            </div>
          </div>
        </div>
      </section>
      {/*/ End Contact Us */}



      <Footer />
    </>
  )
}

export default Dashboard